import React, { Component } from "react";
import { Container, Row, Col, Jumbotron } from "reactstrap";
import handleValidation from "../Validation";
import { Link } from "react-router-dom";
import "./style.css";

class ApplyNow extends Component {
  constructor() {
    super();
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      course: "",
      education: "",
      textArea: ""
    };
  }

  submitDetails = event => {
    debugger;
    
    let formData = {
      first_name: this.refs.first_name.value,
      last_name: this.refs.last_name.value,
      email: this.refs.email.value,
      contact: this.refs.contact.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] == true) {
      document.getElementById("applyNow").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("applyNow").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  }

  render() {
    return (
      <div className="dark-background white " style={{ textAlign: "left" }}>
        {/* <NavBar /> */}
        <Jumbotron fluid className="apply-hero ">
          <Row>
            <Col sm={{ size: 6, offset: 2 }}>
              <h1 style={{ marginTop: "20%" }}>
                Start Your Course Application
              </h1>
            </Col>
          </Row>
        </Jumbotron>

        <Container>
          <Row>
            <Col sm={{ size: 10, offset: 1 }}>
              <p className="mt-5">
                Start your course application by submtting your contact
                information, a brief message about yourself and your goals to
                our student advisor team. Once submitted, one of our student
                advisors will reach out to set up a meeting to go over next
                steps of the application process.
                <br /> <br />
                If you have any questions, please feel free to contact us here
                or email us at info@itslighthouse.com.
              </p>
            </Col>
          </Row>

          <Row>
            <Col sm={{ size: 8, offset: 2 }}>
              <div style={{ padding: "2rem" }}>
              <form id="applyNow"
                  action=""
                  method=""
                  onSubmit={this.submitDetails.bind(this)}
                >     
                   <input type="hidden" name="oid" value="00D3i000000GUvA" />    
                   <input type="hidden" name="lead_source" value="Website" />
                  <input type="hidden" name="00N3i00000Bm5C9" value="Apply_now_website_v1" />
                 

                  <input
                    type="hidden"
                    name="retURL"
                    value="https://www.atlighthouse.com/thank-you"
                  />

                  <Row>
                    <Col>
                      <label htmlFor="first_name" className="apply-now-labels">
                        First Name<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="first_name"
                        maxLength="40"
                        name="first_name"
                        size="20"
                        type="text"
                        className="apply-now-inputs form-control"
                        ref="first_name"
                        placeholder="First Name"
                      />
                      {this.state.errorsdiv === true ? (
                        <span className="error">
                          {this.state.errors["first_name"]}
                        </span>
                      ) : (
                        ""
                      )}
                      <br />
                    </Col>
                    <Col>
                      <label htmlFor="last_name" className="apply-now-labels">
                        Last Name<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="last_name"
                        maxLength="80"
                        name="last_name"
                        size="20"
                        type="text"
                        className="apply-now-inputs form-control"
                        ref="last_name"
                        placeholder="Last Name"
                      />
                      {this.state.errorsdiv === true ? (
                        <span className="error">
                          {this.state.errors["last_name"]}
                        </span>
                      ) : (
                        ""
                      )}
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label htmlFor="email" className="apply-now-labels">
                        Email<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="email"
                        maxLength="80"
                        name="email"
                        size="20"
                        type="email"
                        className="apply-now-inputs form-control"
                        ref="email"
                        placeholder="Email"
                      />
                      {this.state.errorsdiv === true ? (
                        <span className="error">
                          {this.state.errors["email"]}
                        </span>
                      ) : (
                        ""
                      )}
                      <br />
                    </Col>
                    <Col>
                      <label htmlFor="phone" className="apply-now-labels">
                        Phone Number<p className="required-symbol">{"*"}</p>
                      </label>
                      <input
                        id="contact"
                        maxLength="40"
                        minLength="10"
                        name="phone"
                        size="20"
                        type="text"
                        className="apply-now-inputs form-control"
                        ref="contact"
                        placeholder="Phone Number"
                      />
                      {this.state.errorsdiv === true ? (
                        <span className="error">
                          {this.state.errors["contact"]}
                        </span>
                      ) : (
                        ""
                      )}
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label
                        className="apply-now-labels"
                        htmlFor="exampleSelect"
                      >
                        What course are you applying for?
                      </label>
                      <select
                        id="00N3i00000Bkld5"
                        name="00N3i00000Bkld5"
                        title="Which course are you applying for?"
                        className="apply-now-inputs form-control"
                      >
                        <option value=""></option>
                        <option value="Full Stack Web Development Immersive">
                          Software Engineering Immersive
                        </option>
                        <option value="Data science and Analytics Immersive">
                          Data science and Analytics Immersive
                        </option>
                        <option value="Digital Marketing Intensive">
                          Digital Marketing Intensive
                        </option>
                        <option value="Experience Design Intensive">
                          Experience Design Intensive
                        </option>
                        <option value="Full Stack Web Development Intensive">
                          Full Stack Web Development Intensive
                        </option>
                        <option value="Data Science &amp; Analytics Intensive">
                          Data Science &amp; Analytics Intensive
                        </option>
                      </select>
                      <br />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label
                        className="apply-now-labels"
                        htmlFor="exampleEmail"
                      >
                        What is your highest level of education?
                      </label>
                      <select
                        id="00N3i00000Bklkf"
                        name="00N3i00000Bklkf"
                        title="Completed education programs?"
                        className="apply-now-inputs form-control"
                      >
                        <option value=""></option>
                        <option value="High School/ GED">
                          High School/ GED
                        </option>
                        <option value="Associates">Associates</option>{" "}
                        <option value="Bachelors">Bachelors</option>
                        <option value="Masters">Masters</option>
                        <option value="PHD">PHD</option>
                        <option value="Bootcamp/Certification">
                          Bootcamp/Certification
                        </option>
                      </select>
                      <br />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <label className="apply-now-labels" htmlFor="exampleText">
                        Tell us about yourself.{" "}
                      </label>
                      <textarea
                        id="00N3i00000Bklln"
                        name="00N3i00000Bklln"
                        rows="8"
                        type="text"
                        wrap="soft"
                        className="apply-now-inputs form-control"
                        placeholder="Tell us briefly about yourself and your goals for the course."
                      ></textarea>
                      <br />
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn btn-secondary"
                      />
                     
                    </Col>
                  </Row>
                </form>

                <Row>
                  <Col>
                    <p className="privacy-terms1">
                      <i>
                        By providing your email, you agree to our{" "}
                        <u>
                          <Link style={{ color: "white" }} to="/privacy-policy">
                            privacy policy
                          </Link>
                        </u>{" "}
                        and{" "}
                        <u>
                          {/* <Link */}
                          {/* style={{ color: "white" }}
                            to="/terms-and-conditions"
                          > */}
                          terms and conditions
                          {/* </Link> */}
                        </u>
                      </i>
                      .
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}



export default ApplyNow;
